import React, { useMemo, useState, useEffect } from "react";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Select,
  SelectItem,
  Checkbox,
} from "@heroui/react";
import AppButton from "../../common/AppButton";

const exportOptions = [
  { key: "full", label: "Erstbearbeitung Transkript (hard)" },
  { key: "full_refined", label: "Stilistische Bearbeitung Transkript (soft)" },
  { key: "speaker", label: "Transkript pro Sprecher" },
  { key: "rawTranscription", label: "Rohes Transkript" },
  { key: "rtf", label: "Agenda" },
];

function isoNow() {
  return new Date().toISOString().replace(/:/g, "-");
}

const ExportModal = ({ isOpen, onClose, sessionName = "Session", previewSpeaker, onStart }) => {
  const [selectedType, setSelectedType] = useState(new Set([]));
  const [showCorrections, setShowCorrections] = useState(false);

    useEffect(() => {
    if (isOpen) {
      setSelectedType(new Set([]));
      setShowCorrections(false);
    }
  }, [isOpen]);

  const selectedKey = Array.from(selectedType)[0];

  const previewFullName = useMemo(
    () => `Export ${sessionName} ${isoNow()}.docx`,
    [sessionName, isOpen]
  );

  const previewSpeakerName = useMemo(() => {
    const spName = previewSpeaker?.name || "Speaker";
    const sectionTs = previewSpeaker?.sectionTimestamp || "00-00-00";
    return `Export ${sessionName} ${spName} ${sectionTs} ${isoNow()}.docx`;
  }, [sessionName, previewSpeaker, isOpen]);

    const handleStart = () => {
        
        if (onStart) {
          if (selectedKey == "full_refined"){
            onStart({ type: "full", softSide: true })
          }else{
            onStart({ type: selectedKey, softSide: false })
          }
        };
        onClose();
    };

  return (
    <Modal isOpen={isOpen} onOpenChange={onClose} size="lg" placement="center">
      <ModalContent>
        {() => (
          <>
            <ModalHeader>Export Einstellungen</ModalHeader>
            <ModalBody className="space-y-4">
              <div className="space-y-1">
                <label className="text-sm font-medium">Exporttyp</label>
                <Select
                  aria-label="Exporttyp"
                  placeholder="Bitte auswählen"
                  selectedKeys={selectedType}
                  onSelectionChange={setSelectedType}
                  className=" w-full"
                >
                  {exportOptions.map(o => (
                    <SelectItem key={o.key}>{o.label}</SelectItem>
                  ))}
                </Select>
              </div>

              {/* {selectedKey && (
                <div className="rounded bg-gray-50 p-3 text-sm">
                  <div className="font-medium mb-1">Filename Preview</div>
                  <code className="break-all">
                    {selectedKey === "full" ? previewFullName : previewSpeakerName}
                  </code>
                </div>
              )} */}
            </ModalBody>
            <ModalFooter>
              <Button variant="bordered" color="danger" radius="full" onPress={onClose}>
                Cancel
              </Button>
              <AppButton width="w-[170px]" onClick={handleStart} disabled={!selectedKey}>
                Export Starten
              </AppButton>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};

export default ExportModal;
